import memoizeOne from 'memoize-one';
import React from 'react';

import Loader from 'components/Loader/Loader';

import TargetingMultiSelect from 'features/targeting/components/TargetingMultiSelect/TargetingMultiSelect';

import { IFormProps } from 'interfaces';
import {
  useAllDeviceMakersQuery,
  DeviceMakerAttributes,
} from 'interfaces/generated.types';

import { ITargetingComponentProps } from 'utils/targetingDefinitions';

export const deviceMakerValues = {
  deviceMakerParams: {
    deviceMakers: [],
  },
};

const formatData = memoizeOne((data: DeviceMakerAttributes[]) =>
  data.map((deviceMaker: DeviceMakerAttributes) => ({
    label: deviceMaker.name,
    options: deviceMaker.models.map((model: string) => ({
      label: model,
      value: model,
      maker: deviceMaker.name,
    })),
  }))
);
const TargetingDeviceModel = (
  props: IFormProps<any> & ITargetingComponentProps
) => {
  const { loading, data } = useAllDeviceMakersQuery({
    fetchPolicy: 'cache-first',
  });

  if (loading) return <Loader />;

  return (
    <TargetingMultiSelect
      {...props}
      label="Device Model"
      targetingName="deviceMakerParams.deviceMakers"
      options={
        data && data.allDeviceMakers ? formatData(data.allDeviceMakers) : []
      }
    />
  );
};

export default TargetingDeviceModel;
